import axios from 'axios';
import loadingSpinnerGif from './../assets/loading.gif';

export const isEuroasia = false;
export const isBenby = false;
export const myServer = false;
export const isBatangas = true;

// Function to check if the token is expired
const isTokenExpired = (expirationTime) => {
    return Date.now() >= expirationTime;
};
// Function to generate a new token
const generateToken = async () => {
    try {
        const apiUrl =  domain + "/api/Authentication/login";
        const data = {
            userName: "admin",
            password: "password"
        };
        const response = await axios.post(apiUrl, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const token = response.data.token;
        const expirationTime = Date.now() + (60 * 60 * 1000); // Assuming token expires in 1 hour
        localStorage.setItem('token', token);
        localStorage.setItem('tokenExpiration', expirationTime);
        return token;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};
// Function to get the token
const getToken = async () => {
    const token = localStorage.getItem('token');
    const tokenExpiration = localStorage.getItem('tokenExpiration');

    if (!token || !tokenExpiration || isTokenExpired(Number(tokenExpiration))) {
        return await generateToken();
    } else {
        return token;
    }
};

//Config 1
//Web
const getDomainDefaultIpAddress = () =>{
    let value = "";

    if(isEuroasia){
        value = "192.168.254.15";
    } else if(isBenby){
        value = "172.16.84.125";
    } else if(myServer){
        value = "192.168.150.40";
    } else if(isBatangas){
        value = "192.168.10.163";
    }

    return value;
}
const getDomainDefaultPort = () =>{
    let value = "";

    if(isEuroasia){
        value = "8002";
    } else if(isBenby){
        value = "8005"
    } else if(myServer){
        value = "8005";
    } else if(isBatangas){
        value = "8005";
    }

    return value;
}
//Bio
const getDomainDefaultIpAddressBiometrics = () =>{
    let value = "";

    if(isEuroasia){
        value = "192.168.254.15";
    } else if(isBenby){
        value = "172.16.84.125";
    } else if(myServer){
        value = "192.168.150.40";
    } else if(isBatangas){
        value = "192.168.10.163";
    }

    return value;
}
const getDomainDefaultPortBiometrics = () =>{
    let value = "";

    if(isEuroasia){
        value = "8003";
    } else if(isBenby){
        value = "8002";
    } else if(myServer){
        value = "8007";
    } else if(isBatangas){
        value = "8003";
    }

    return value;
}

//Config 2
//Web
const getDomainDefaultIpAddress2 = () =>{
    let value = "";

    if(isEuroasia){
        value = "161.49.93.114";
    } else if(isBenby){
        value = "172.16.84.125";
    } else if(myServer){
        value = "192.168.150.40";
    } else if(isBatangas){
        value = "192.168.10.163";
    }

    return value;
}
const getDomainDefaultPort2 = () =>{
    let value = "";

    if(isEuroasia){
        value = "8002";
    } else if(isBenby){
        value = "8005";
    } else if(myServer){
        value = "8005";
    } else if(isBatangas){
        value = "8005";
    }

    return value;
}
//Bio
const getDomainDefaultIpAddressBiometrics2 = () =>{
    let value = "";

    if(isEuroasia){
        value = "192.168.254.15";
    } else if(isBenby){
        value = "172.16.84.125";
    } else if(myServer){
        value = "192.168.150.40";
    } else if(isBatangas){
        value = "192.168.10.163";
    }

    return value;
}
const getDomainDefaultPortBiometrics2 = () =>{
    let value = "";

    if(isEuroasia){
        value = "8003";
    } else if(isBenby){
        value = "8002";
    } else if(myServer){
        value = "8007";
    } else if(isBatangas){
        value = "8003";
    }

    return value;
}

//Web domain
//My working pc
// let defaultIpAddress = "192.168.150.40";
// let defaultPort = "8201";

// Config 1
let defaultIpAddress = getDomainDefaultIpAddress();
let defaultPort = getDomainDefaultPort();

// Config 2
let defaultIpAddress2 = getDomainDefaultIpAddress2();
let defaultPort2 = getDomainDefaultPort2();

// Config 1
let selectedIPAddress = localStorage.getItem('selectedIPAddress') || defaultIpAddress;
let selectedPort = localStorage.getItem('selectedPort') || defaultPort;
let defaultDomain = `http://${defaultIpAddress}:${defaultPort}`;
let selectedDomain = localStorage.getItem('selectedDomain') || defaultDomain;

// Config 2
let selectedIPAddress2 = localStorage.getItem('selectedIPAddress2') || defaultIpAddress2;
let selectedPort2 = localStorage.getItem('selectedPort2') || defaultPort2;
let defaultDomain2 = `http://${defaultIpAddress2}:${defaultPort2}`;
let selectedDomain2 = localStorage.getItem('selectedDomain2') || defaultDomain2;

//Biometrics
//My working pc
// let defaultIpAddressBiometrics = "192.168.150.40";
// let defaultPortBiometrics = "8100";

// Config 1
let defaultIpAddressBiometrics = getDomainDefaultIpAddressBiometrics();
let defaultPortBiometrics = getDomainDefaultPortBiometrics();

// Config 2
let defaultIpAddressBiometrics2 = getDomainDefaultIpAddressBiometrics2();
let defaultPortBiometrics2 = getDomainDefaultPortBiometrics2();

// Config 1
let selectedIPAddressBiometrics = localStorage.getItem('selectedIPAddressBiometrics') || defaultIpAddressBiometrics;
let selectedPortBiometrics = localStorage.getItem('selectedPortBiometrics') || defaultPortBiometrics;
let defaultDomainBiometrics = `http://${defaultIpAddressBiometrics}:${defaultPortBiometrics}`;
let selectedDomainBiometrics = localStorage.getItem('selectedDomainBiometrics') || defaultDomainBiometrics;

// Config 2
let selectedIPAddressBiometrics2 = localStorage.getItem('selectedIPAddressBiometrics2') || defaultIpAddressBiometrics2;
let selectedPortBiometrics2 = localStorage.getItem('selectedPortBiometrics2') || defaultPortBiometrics2;
let defaultDomainBiometrics2 = `http://${defaultIpAddressBiometrics2}:${defaultPortBiometrics2}`;
let selectedDomainBiometrics2 = localStorage.getItem('selectedDomainBiometrics2') || defaultDomainBiometrics2;

//Web
// Config 1
export const updateSelectedDomain = () => {
    selectedDomain = `http://${selectedIPAddress}:${selectedPort}`;
    localStorage.setItem('selectedDomain', selectedDomain);
};
export const setRootIPAddress = (ipAddress) => {
    selectedIPAddress = ipAddress;
    localStorage.setItem('selectedIPAddress', ipAddress);
    updateSelectedDomain();
    localStorage.setItem('currentDomain', null);
    localStorage.setItem('currentDomainBiometrics', null);
};
export const setRootPort = (port) => {
    selectedPort = port;
    localStorage.setItem('selectedPort', port);
    updateSelectedDomain();
    localStorage.setItem('currentDomain', null);
    localStorage.setItem('currentDomainBiometrics', null);
};
export const resetDomainRootId = () => {
    selectedDomain = defaultDomain;
    localStorage.setItem('selectedDomain', defaultDomain);
    selectedIPAddress = defaultIpAddress;
    localStorage.setItem('selectedIPAddress', defaultIpAddress);
    selectedPort = defaultPort;
    localStorage.setItem('selectedPort', defaultPort);
    resetDomainRootIdBiometrics();
};

export const getIPAddress = () => {
    return selectedIPAddress;
};
export const getPort = () => {
    return selectedPort;
};

let currentDomainValue = localStorage.getItem('currentDomain');

if (currentDomainValue === null) {
    // If not in localStorage, initialize it with null
    currentDomainValue = null;
}

export const getDomain = async () => {
    if (currentDomainValue !== "null" 
        && currentDomainValue !== null
        && currentDomainValue !== undefined
        && currentDomainValue !== ""
    ) {
        return currentDomainValue;
    }

    let loadingSpinner = null;
    
    try {
        loadingSpinner = createLoadingSpinner();

        const response = await fetch(selectedDomain);
        if (!response.ok) {
            throw new Error('Failed to reach selectedDomain');
        }
        currentDomainValue = selectedDomain;
        
        localStorage.setItem('currentDomain', currentDomainValue);
        removeLoadingSpinner(loadingSpinner);
        return currentDomainValue;
    } catch (error) {
        console.error("Error reaching selectedDomain:", error);

        removeLoadingSpinner(loadingSpinner);
        
        currentDomainValue = selectedDomain2;
        localStorage.setItem('currentDomain', currentDomainValue);
        return currentDomainValue;
    }
};

// Config 2
export const updateSelectedDomain2 = () => {
    selectedDomain2 = `http://${selectedIPAddress2}:${selectedPort2}`;
    localStorage.setItem('selectedDomain2', selectedDomain2);
};
export const setRootIPAddress2 = (ipAddress) => {
    selectedIPAddress2 = ipAddress;
    localStorage.setItem('selectedIPAddress2', ipAddress);
    updateSelectedDomain2();
    localStorage.setItem('currentDomain', null);
    localStorage.setItem('currentDomainBiometrics', null);
};
export const setRootPort2 = (port) => {
    selectedPort2 = port;
    localStorage.setItem('selectedPort2', port);
    updateSelectedDomain2();
    localStorage.setItem('currentDomain', null);
    localStorage.setItem('currentDomainBiometrics', null);
};
export const resetDomainRootId2 = () => {
    selectedDomain2 = defaultDomain2;
    localStorage.setItem('selectedDomain2', defaultDomain2);
    selectedIPAddress2 = defaultIpAddress2;
    localStorage.setItem('selectedIPAddress2', defaultIpAddress2);
    selectedPort2 = defaultPort2;
    localStorage.setItem('selectedPort2', defaultPort2);
    resetDomainRootIdBiometrics2();
};

export const getIPAddress2 = () => {
    return selectedIPAddress2;
};
export const getPort2 = () => {
    return selectedPort2;
};
export const getDomain2 = () => {
    return selectedDomain2;
};

//Biometrics
//Config 1
export const updateSelectedDomainBiometrics = () => {
    selectedDomainBiometrics = `http://${selectedIPAddressBiometrics}:${selectedPortBiometrics}`;
    localStorage.setItem('selectedDomainBiometrics', selectedDomainBiometrics);
};
export const setRootIPAddressBiometrics = (ipAddressBiometrics) => {
    selectedIPAddressBiometrics = ipAddressBiometrics;
    localStorage.setItem('selectedIPAddressBiometrics', ipAddressBiometrics);
    updateSelectedDomainBiometrics();
    localStorage.setItem('currentDomain', null);
    localStorage.setItem('currentDomainBiometrics', null);
};
export const setRootPortBiometrics = (portBiometrics) => {
    selectedPortBiometrics = portBiometrics;
    localStorage.setItem('selectedPortBiometrics', portBiometrics);
    updateSelectedDomainBiometrics();
    localStorage.setItem('currentDomain', null);
    localStorage.setItem('currentDomainBiometrics', null);
};
export const resetDomainRootIdBiometrics = () => {
    selectedDomainBiometrics = defaultDomainBiometrics;
    localStorage.setItem('selectedDomainBiometrics', defaultDomainBiometrics);
    selectedIPAddressBiometrics = defaultIpAddressBiometrics;
    localStorage.setItem('selectedIPAddressBiometrics', defaultIpAddressBiometrics);
    selectedPortBiometrics = defaultPortBiometrics;
    localStorage.setItem('selectedPortBiometrics', defaultPortBiometrics);
};

export const getIPAddressBiometrics = () => {
    return selectedIPAddressBiometrics;
};
export const getPortBiometrics = () => {
    return selectedPortBiometrics;
};

let currentDomainBiometricsValue = localStorage.getItem('currentDomainBiometrics');

if (currentDomainBiometricsValue === null) {
    // If not in localStorage, initialize it with null
    currentDomainBiometricsValue = null;
}

export const getDomainBiometrics = async () => {
    if (currentDomainBiometricsValue !== "null" 
        && currentDomainBiometricsValue !== null
        && currentDomainBiometricsValue !== undefined
        && currentDomainBiometricsValue !== ""
    ) {
        return currentDomainBiometricsValue;
    }

    let loadingSpinner = null;
    
    try {
        loadingSpinner = createLoadingSpinner();

        const response = await fetch(`${selectedDomainBiometrics}/swagger`);
        if (!response.ok) {
            throw new Error('Failed to reach selectedDomainBiometrics');
        }
        
        currentDomainBiometricsValue = selectedDomainBiometrics;
        
        localStorage.setItem('currentDomainBiometrics', currentDomainBiometricsValue);
        removeLoadingSpinner(loadingSpinner);
        return currentDomainBiometricsValue;
    } catch (error) {
        console.error("Error reaching selectedDomainBiometrics:", error);

        removeLoadingSpinner(loadingSpinner);
        
        currentDomainBiometricsValue = selectedDomainBiometrics2;
        localStorage.setItem('currentDomainBiometrics', currentDomainBiometricsValue);
        return currentDomainBiometricsValue;
    }
};

//Config 2
export const updateSelectedDomainBiometrics2 = () => {
    selectedDomainBiometrics2 = `http://${selectedIPAddressBiometrics2}:${selectedPortBiometrics2}`;
    localStorage.setItem('selectedDomainBiometrics2', selectedDomainBiometrics2);
};
export const setRootIPAddressBiometrics2 = (ipAddressBiometrics) => {
    selectedIPAddressBiometrics2 = ipAddressBiometrics;
    localStorage.setItem('selectedIPAddressBiometrics2', ipAddressBiometrics);
    updateSelectedDomainBiometrics2();
    localStorage.setItem('currentDomain', null);
    localStorage.setItem('currentDomainBiometrics', null);
};
export const setRootPortBiometrics2 = (portBiometrics) => {
    selectedPortBiometrics2 = portBiometrics;
    localStorage.setItem('selectedPortBiometrics2', portBiometrics);
    updateSelectedDomainBiometrics2();
    localStorage.setItem('currentDomain', null);
    localStorage.setItem('currentDomainBiometrics', null);
};
export const resetDomainRootIdBiometrics2 = () => {
    selectedDomainBiometrics2 = defaultDomainBiometrics2;
    localStorage.setItem('selectedDomainBiometrics2', defaultDomainBiometrics2);
    selectedIPAddressBiometrics2 = defaultIpAddressBiometrics2;
    localStorage.setItem('selectedIPAddressBiometrics2', defaultIpAddressBiometrics2);
    selectedPortBiometrics2 = defaultPortBiometrics2;
    localStorage.setItem('selectedPortBiometrics2', defaultPortBiometrics2);
};

export const getIPAddressBiometrics2 = () => {
    return selectedIPAddressBiometrics2;
};
export const getPortBiometrics2 = () => {
    return selectedPortBiometrics2;
};
export const getDomainBiometrics2 = () => {
    return selectedDomainBiometrics2;
};

const createLoadingSpinner = () => {
    // Create a container for the spinner and message
    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.top = '50%';
    container.style.left = '50%';
    container.style.transform = 'translate(-50%, -50%)';
    container.style.zIndex = '9999';
    container.style.textAlign = 'center';
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.alignItems = 'center';
    container.style.justifyContent = 'center';

    // Create the loading spinner image
    const loadingSpinner = document.createElement('img');
    loadingSpinner.src = loadingSpinnerGif;
    loadingSpinner.alt = 'Loading...';
    loadingSpinner.style.display = 'block';
    loadingSpinner.style.marginBottom = '10px';

    // Create the message element
    const message = document.createElement('div');
    message.innerText = 'Trying to connect to server';
    message.style.color = '#000'; // Adjust the color as needed
    message.style.fontSize = '16px'; // Adjust the font size as needed

    // Append the spinner and message to the container
    container.appendChild(loadingSpinner);
    container.appendChild(message);

    // Append the container to the body
    document.body.appendChild(container);

    return container;
};

// Function to remove loading spinner from the DOM
const removeLoadingSpinner = (loadingSpinner) => {
    if (loadingSpinner) {
        document.body.removeChild(loadingSpinner);
    }
};

export const isLoanFullView = (type) =>{
    let value = false;

    switch (type) {
        case "Admin":
            value = true;
            break;
        case "Accounting Head":
            value = true;
            break;
        case "HR Admin":
            value = true;
            break;
        case "HR Assistant":
            value = true;
            break;
        case "Employee":
            value = false;
            break;
        default:
            value = false;
            break;
    }

    return value;
}

//Others
let defaultTimeFormat = "Standard Time";
let selectedTimeFormat = localStorage.getItem('selectedTimeFormat') || defaultTimeFormat;
export const setRootTimeFormat = (timeFormat) => {
    selectedTimeFormat = timeFormat;
    localStorage.setItem('selectedTimeFormat', timeFormat);
};
export const getTimeFormat = () => {
    return selectedTimeFormat;
};
export const globalTimeFormat = getTimeFormat();

// export const domain = `https://localhost:44368`; //my personal
// export const domain = `http://192.168.10.157:10525`; //my personal
// export const domain = `http://11.11.201.244:9002`; //donlee
// export const domain = `http://180.232.171.235:9002`; //donlee
export const domain = 'https://dlbi-portal.org' // dj
export const token = await getToken();